// ── Catégories IA haute-niveau ─────────────────────────────────────────────────
export const IA_CATEGORIES = {
  Animal:           { key: 'Animal',          color: '#26b36a', emoji: '🐾' },
  Construction:     { key: 'Construction',    color: '#e07b00', emoji: '🏗️' },
  Domestique:       { key: 'Domestique',      color: '#6a0572', emoji: '🏠' },
  Musique:          { key: 'Musique',         color: '#e91e63', emoji: '🎵' },
  Urbain:           { key: 'Urbain',          color: '#00838f', emoji: '🏢' },
  'Voix humaine':   { key: 'Voix humaine',    color: '#0077b6', emoji: '🗣️' },
  Véhicule:         { key: 'Véhicule',        color: '#c0392b', emoji: '🚘' },

  // ── Outils / Construction ──────────────────────────────────────────────────
  'Marteau-piqueur':         { color: '#e07b00', emoji: '⛏️' },
  'Marteau':                 { color: '#e07b00', emoji: '🔨' },
  'Sciage':                  { color: '#e07b00', emoji: '🪚' },
  'Perçage':                 { color: '#e07b00', emoji: '🛠️' },
  'Outil électrique':        { color: '#e07b00', emoji: '⚡' },
  'Râpage':                  { color: '#e07b00', emoji: '🛠️' },
  'Ponçage':                 { color: '#e07b00', emoji: '🪵' },
  'Hachage':                 { color: '#e07b00', emoji: '🔪' },

  // ── Moteurs ───────────────────────────────────────────────────────────────
  'Moteur lourd':            { color: '#c0392b', emoji: '🚜' },
  'Moteur moyen':            { color: '#c0392b', emoji: '🚧' },
  'Moteur léger':            { color: '#c0392b', emoji: '🛠️' },
  'Moteur':                  { color: '#c0392b', emoji: '⚙️' },
  'Cognement du moteur':     { color: '#c0392b', emoji: '⚙️' },
  'Démarrage du moteur':     { color: '#c0392b', emoji: '🔑' },
  'Ralenti':                 { color: '#c0392b', emoji: '🚜' },
  'Accélération':            { color: '#c0392b', emoji: '🚜' },

  // ── Véhicules ─────────────────────────────────────────────────────────────
  'Camion':                  { color: '#c0392b', emoji: '🚛' },
  'Frein à air':             { color: '#c0392b', emoji: '💨' },
  'Klaxon de camion':        { color: '#c0392b', emoji: '📢' },
  'Bip de recul':            { color: '#c0392b', emoji: '🔊' },
  'Véhicule':                { color: '#c0392b', emoji: '🚗' },
  'Véhicule motorisé':       { color: '#c0392b', emoji: '🚚' },
  'Ventilateur mécanique':   { color: '#00838f', emoji: '🌀' },

  // ── Impacts / Fracas ─────────────────────────────────────────────────────
  'Craquement':              { color: '#7b2d8b', emoji: '🧱' },
  'Fracas':                  { color: '#7b2d8b', emoji: '💥' },
  'Cassure':                 { color: '#7b2d8b', emoji: '🧱' },
  'Détonation':              { color: '#7b2d8b', emoji: '💥' },
  'Bruit sourd':             { color: '#7b2d8b', emoji: '🔨' },
  'Cliquetis':               { color: '#7b2d8b', emoji: '🔧' },
  'Grondement':              { color: '#7b2d8b', emoji: '🔊' },
  'Couinement':              { color: '#7b2d8b', emoji: '🛞' },
  'Grincement':              { color: '#7b2d8b', emoji: '🏗️' },
  'Vrombissement':           { color: '#7b2d8b', emoji: '⚙️' },
  'Raclement':               { color: '#7b2d8b', emoji: '🧱' },
  'Frottement':              { color: '#7b2d8b', emoji: '🪨' },

  // ── Matériaux ─────────────────────────────────────────────────────────────
  'Bois':                    { color: '#6b4226', emoji: '🪵' },
  'Couper':                  { color: '#6b4226', emoji: '🪓' },
  'Éclatement':              { color: '#6b4226', emoji: '🪵' },
  'Verre':                   { color: '#5bc8d4', emoji: '🪟' },
  'Briser':                  { color: '#7b2d8b', emoji: '🪟' },
};

export const ICON_EMOJI = {
  ...Object.fromEntries(Object.values(IA_CATEGORIES).map(({ key, emoji }) => [key ?? '', emoji])),
  diamond: null,
  circle:  '',
};

// ── Mots-clés pour la détection automatique ────────────────────────────────────
const CATEGORY_KEYWORDS = {
  Animal: [
    'animal', 'chien', 'chat', 'oiseau', 'insecte', 'grenouille', 'coq',
    'vache', 'cheval', 'mouton', 'porc', 'cochon', 'lapin', 'pigeon',
    'mouette', 'corbeau', 'merle', 'abeille', 'grillon', 'cigale',
    'dog', 'cat', 'bird', 'crow', 'seagull', 'cricket', 'frog', 'bee',
    'wildlife', 'faune', 'fauna',
  ],
  Construction: [
    'excavatrice', 'excavateur', 'compresseur', 'béton', 'beton',
    'grue', 'foreuse', 'bulldozer', 'travaux', 'meuleuse', 'perforateur',
    'pelleteuse', 'jackhammer', 'drilling', 'crane', 'excavator', 'construction',
    'compressor', 'chantier',
  ],
  Domestique: [
    'aspirateur', 'lave-vaisselle', 'machine à laver', 'sèche-linge',
    'four', 'micro-onde', 'microonde', 'réfrigérateur', 'refrigerateur', 'frigo',
    'ventilateur', 'climatisation', 'clim', 'chauffage', 'bouilloire',
    'cafetière', 'cafetiere', 'vacuum', 'dishwasher', 'washing', 'dryer',
    'domestique', 'ménage', 'menage', 'électroménager', 'electromenager',
  ],
  Musique: [
    'musique', 'music', 'concert', 'guitare', 'guitar', 'piano',
    'batterie', 'drums', 'violon', 'violin', 'trompette', 'trumpet',
    'flûte', 'flute', 'saxophone', 'sax', 'orchestre', 'orchestra',
    'chant', 'chanson', 'song', 'mélodie', 'melodie', 'melody', 'instrument',
    'basse', 'bass', 'synthé', 'synthe', 'synth',
  ],
  Urbain: [
    'foule', 'crowd', 'clameur', 'marché', 'marche', 'market', 'restaurant',
    'café', 'cafe', 'bar', 'rue', 'street', 'parc', 'park', 'ville', 'city',
    'urbain', 'urban', 'bruit de fond', 'ambiance', 'atmosphère', 'atmosphere',
    'fête', 'fete', 'festival', 'alarme', 'alarm', 'explosion',
    "feux d'artifice", 'firework',
  ],
  'Voix humaine': [
    'voix', 'voice', 'parole', 'speech', 'discours', 'conversation',
    'dialogue', 'enfant', 'child', 'bébé', 'bebe', 'baby', 'cri', 'scream',
    'chuchotement', 'whisper', 'rire', 'laugh', 'pleur', 'cry',
    'humain', 'human', 'personne', 'person', 'appel', 'voix humaine',
  ],
  Véhicule: [
    'voiture', 'car', 'metro', 'tramway', 'tram', 'avion', 'airplane',
    'hélicoptère', 'helicoptere', 'helicopter', 'train',
    'bus', 'moto', 'motorcycle', 'trafic', 'traffic',
  ],

  // ── Sons spécifiques (correspondance directe avant les catégories) ────────
  'Marteau-piqueur': ['marteau-piqueur', 'marteau piqueur', 'jackhammer', 'perforateur'],
  'Marteau':         ['marteau', 'hammer'],
  'Sciage':          ['sciage', 'scie', 'sawing', 'saw'],
  'Perçage':         ['perçage', 'percage', 'perceuse', 'drill', 'drilling', 'percer'],
  'Outil électrique':['outil électrique', 'outil electrique', 'electric tool', 'power tool'],
  'Râpage':          ['râpage', 'rapage', 'lime', 'grinding', 'râper', 'raper'],
  'Ponçage':         ['ponçage', 'poncage', 'ponceuse', 'sanding', 'poncer'],
  'Hachage':         ['hachage', 'découpe alimentaire', 'decoupe', 'hacher', 'couteau', 'knife'],
  'Moteur lourd':    ['moteur lourd', 'basses fréquences', 'basses frequences', 'heavy engine'],
  'Moteur moyen':    ['moteur moyen', 'fréquences moyennes', 'frequences moyennes', 'medium engine'],
  'Moteur léger':    ['moteur léger', 'moteur leger', 'hautes fréquences', 'hautes frequences', 'light engine'],
  'Moteur':          ['moteur', 'engine', 'motor'],
  'Cognement du moteur': ['cognement', 'engine knock', 'claquement moteur'],
  'Démarrage du moteur': ['démarrage', 'demarrage', 'engine start', 'startup'],
  'Ralenti':         ['ralenti', 'idle', 'tick-over'],
  'Accélération':    ['accélération', 'acceleration', 'montée en régime', 'montee en regime', 'rev up'],
  'Camion':          ['camion', 'truck', 'poids lourd', 'semi'],
  'Frein à air':     ['frein à air', 'frein a air', 'air brake', 'frein pneumatique'],
  'Klaxon de camion':['klaxon', 'avertisseur pneumatique', 'horn', 'klaxon de camion'],
  'Bip de recul':    ['bip de recul', 'recul', 'backup beep', 'reverse beep'],
  'Véhicule motorisé':['véhicule motorisé', 'vehicule motorise', 'routier', 'motorized vehicle'],
  'Ventilateur mécanique':['ventilateur mécanique', 'ventilateur mecanique', 'mechanical fan', 'fan noise'],
  'Craquement':      ['craquement', 'crack', 'snap', 'craquer'],
  'Fracas':          ['fracas', 'collision', 'crash', 'impact'],
  'Cassure':         ['cassure', 'bris', 'break', 'breakage', 'casser'],
  'Détonation':      ['détonation', 'detonation', 'bang', 'blast', 'explosion'],
  'Bruit sourd':     ['bruit sourd', 'coup sourd', 'thud', 'thump'],
  'Cliquetis':       ['cliquetis', 'fracas léger', 'fracas leger', 'rattle', 'clatter'],
  'Grondement':      ['grondement', 'rumble', 'gronder', 'thunder'],
  'Couinement':      ['couinement', 'squeak', 'squeal', 'couiner'],
  'Grincement':      ['grincement', 'creak', 'screech', 'grincer'],
  'Vrombissement':   ['vrombissement', 'ronronnement', 'hum', 'buzz', 'drone'],
  'Raclement':       ['raclement', 'frottement de surface', 'scrape', 'racler'],
  'Frottement':      ['frottement', 'friction', 'rubbing', 'frotter'],
  'Bois':            ['bois', 'wood', 'timber', 'lumber'],
  'Couper':          ['couper à coups', 'abattre', 'chop', 'axe', 'hache'],
  'Éclatement':      ['éclatement', 'eclatement', 'écharde', 'echarde', 'splinter'],
  'Verre':           ['verre', 'glass'],
  'Briser':          ['briser', 'voler en éclats', 'voler en eclats', 'shatter', 'smash'],
};

// Ordre de vérification : sons spécifiques d'abord (plus précis), puis catégories larges
const SPECIFIC_SOUNDS = [
  'Marteau-piqueur', 'Marteau', 'Sciage', 'Perçage', 'Outil électrique',
  'Râpage', 'Ponçage', 'Hachage',
  'Moteur lourd', 'Moteur moyen', 'Moteur léger',
  'Cognement du moteur', 'Démarrage du moteur', 'Ralenti', 'Accélération',
  'Camion', 'Frein à air', 'Klaxon de camion', 'Bip de recul',
  'Véhicule motorisé', 'Ventilateur mécanique',
  'Craquement', 'Fracas', 'Cassure', 'Détonation', 'Bruit sourd',
  'Cliquetis', 'Grondement', 'Couinement', 'Grincement', 'Vrombissement',
  'Raclement', 'Frottement',
  'Bois', 'Couper', 'Éclatement', 'Verre', 'Briser',
];

const HIGH_LEVEL_CATEGORIES = [
  'Animal', 'Construction', 'Domestique', 'Musique', 'Urbain', 'Voix humaine', 'Véhicule',
];

export function detectCategory(labelText) {
  if (!labelText) return null;
  const normalized = labelText.toLowerCase().trim();

  // 1. Correspondance exacte (insensible à la casse) sur toutes les entrées
  const exactMatch = Object.keys(IA_CATEGORIES).find(
    (cat) => cat.toLowerCase() === normalized
  );
  if (exactMatch) return exactMatch;

  // 2. Sons spécifiques en priorité (avant les catégories larges)
  for (const sound of SPECIFIC_SOUNDS) {
    const keywords = CATEGORY_KEYWORDS[sound] || [];
    if (keywords.some((kw) => normalized.includes(kw.toLowerCase()))) return sound;
  }

  // 3. Catégories haute-niveau
  for (const cat of HIGH_LEVEL_CATEGORIES) {
    const keywords = CATEGORY_KEYWORDS[cat] || [];
    if (keywords.some((kw) => normalized.includes(kw.toLowerCase()))) return cat;
  }

  return null;
}
